import { render, staticRenderFns } from "./JobDescription.vue?vue&type=template&id=dcfc22f2&scoped=true"
import script from "./JobDescription.vue?vue&type=script&lang=js"
export * from "./JobDescription.vue?vue&type=script&lang=js"
import style0 from "./JobDescription.vue?vue&type=style&index=0&id=dcfc22f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfc22f2",
  null
  
)

export default component.exports